import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccessService } from 'src/app/public/access/access.service';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate {

  constructor(private accessService: AccessService, private router: Router) { }

  // Validate auth routes
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const isAuth = this.accessService.getIsAuth();
    if (!isAuth) {
      this.router.navigate(["/"]);
    }
    return isAuth;
  }

}
